<template>
	<p-card class=" guideline-job-list">
		<template v-if="jobList.length < 1">
			<div class="empty-list tw-flex tw-justify-center tw-items-center tw-w-full">
				<div class="empty-job-card tw-w-1/2 lg:tw-w-1/3 2xl:tw-w-1/5"></div>
				<p class="tw-text-center">Agrega todos los puestos de TRABAJO DE  tu empresa</p>
			</div>
		</template>
		<template v-if="jobList.length > 0">
			<div v-for="group in groupedJobs" :key="group.key" class="tw-mb-6">
				<div class="tw-mb-3">
					<span class="area-title">
						Área: {{ group.areaName }} - Jefe de Área:
						<span v-if="group.areaManager" class="area-manager-name">{{ group.areaManager }}</span>
						<span v-else class="area-manager-missing">Sin asignar</span>
					</span>
				</div>
				<div class="tw-flex tw-flex-wrap tw--mx-2">
					<div
						v-for="job in group.jobs"
						:key="job.name"
						class="tw-w-1/2 lg:tw-w-1/3 2xl:tw-w-1/5 tw-px-2 tw-mb-4"
					>
						<guideline-model-job-item
							:job="job"
							:completed="job.completed"
							:selected="selectedJob.name === job.name"
							@deleteClick="$emit('deleteClick', $event)"
							@editionClick="$emit('editionClick', $event)"
						/>
					</div>
				</div>
			</div>
		</template>
	</p-card>
</template>

<script>
import GuidelineModelJobItem from '@/modules/job-evaluation/components/supplies/guideline-model/jobs-manager/job-list/guideline-model-job-item';
import PCard from '@/modules/shared/components/ui/Card/p-card';

export default {
	name: 'guideline-job-list',
	components: { PCard, GuidelineModelJobItem },
	props: ['jobList', 'selectedJob', 'groups'],
	computed: {
		areaNames() {
			const names = {};
			(this.groups || []).forEach((g) => {
				names[g.id] = g.name;
			});
			return names;
		},
		groupedJobs() {
			const areaMap = {};
			this.jobList.forEach((job) => {
				const key = job.areaId || 'no-area';
				if (!areaMap[key]) {
					areaMap[key] = {
						key,
						areaId: job.areaId,
						areaName: this.areaNames[job.areaId] || 'Sin área',
						jobs: [],
						areaManager: null,
					};
				}
				areaMap[key].jobs.push(job);
				if (job.isAreaManager) {
					areaMap[key].areaManager = job.name;
				}
			});
			return Object.values(areaMap)
				.sort((a, b) => a.areaName.localeCompare(b.areaName))
				.map(group => ({
					...group,
					jobs: [...group.jobs].sort((a, b) => a.name.localeCompare(b.name)),
				}));
		},
	},
};
</script>

<style lang='scss' scoped>
 .guideline-job-list {
	 min-height: 450px;
	 .empty-list {
		 position: relative;
		 min-height: 450px;
		 .empty-job-card {
			 position: absolute;
			 padding: inherit;
			 top: 0;
			 left: 0;
			 height: 30%;
			 border: 2px dashed #9b9b9b;
			 border-radius: 10px;
		 }
		 p {
			 text-transform: uppercase;
			 color: #9b9b9b;
			 width: 200px;
		 }
	 }
	 .area-title {
		 font-size: 12px;
		 font-weight: 600;
		 text-transform: uppercase;
		 color: var(--app-color-primary);
	 }
	 .area-manager-name {
		 color: var(--app-color-info);
		 font-weight: 400;
	 }
	 .area-manager-missing {
		 color: #e67e22;
		 font-style: italic;
		 font-weight: 400;
	 }
 }
</style>



// WEBPACK FOOTER //
// src/modules/job-evaluation/components/supplies/guideline-model/jobs-manager/job-list/guideline-job-list.vue